export const serviceConfig = {
  baseUrl:
    process.env.REACT_APP_API_BASE_URL || "https://gateway-uat.vietmoney.vn",
};
